import { Moment } from 'moment';
//
// NONE
// ORDER_FAILED
// COMPLETED
// RESERVED
// MATCHING
// MATCHED
// PICKUP_WAITING
// PICKUP_STARTED
// PICKUP_COMPLETED
// DROPOFF_WAITING
// DROPOFF_STARTED
// CANCELED
// MATCHING_FAILED
// ABORTED

// 퀵 주문 상태
export type TQuickOrderStatus =
  | 'NONE'
  | 'ORDER_FAILED'
  | 'COMPLETED'
  | 'RESERVED'
  | 'MATCHING'
  | 'MATCHED'
  | 'PICKUP_WAITING'
  | 'PICKUP_STARTED'
  | 'PICKUP_COMPLETED'
  | 'DROPOFF_WAITING'
  | 'DROPOFF_STARTED'
  | 'CANCELED'
  | 'MATCHING_FAILED'
  | 'ABORTED';

export type TDisplayStatus =
  | 'ORDER_CANCELLED'
  | 'ORDER_RECEIVED'
  | 'DRIVER_ASSIGNED'
  | 'PICKUP_COMPLETE'
  | 'DELIVERY_COMPLETE';

// 결제 방식
export type TPayMethod = 'NONE' | 'CASH' | 'CREDIT' | 'CARD';

// 물품 종류
export type TQuickGoods = 'XS' | 'S' | 'M' | 'L' | 'DOCUMENTS' | 'SMALLBOX' | 'BIGBOX' | 'OTHERS' | 'GENERAL_FREIGHT';

// 주문 유형
export type TOrderType = 'QUICK' | 'QUICK_ECONOMY' | 'QUICK_EXPRESS' | 'DOBO';

// 배송 수단 유형
export type TDispatchType = 'MINIMUM' | 'REQUIRED';

// 취소 주체
export type TCancelBy = 'PICKER' | 'ADMIN' | 'USER';

// 배송지 타입
export type TAddressType = 'STARTPOINT' | 'WAYPOINT' | 'ENDPOINT';

// 배송 수단
export type TVehicle = 'MOTORCYCLE' | 'JIMBAJI_MOTORCYCLE' | 'PASSENGER_CAR' | 'DAMAS' | 'LABO' | 'TON';

export interface IQuickAddress {
  idx: number;
  quickManagerIdx: number;
  quickAddressBookIdx: number;
  addressType: TAddressType;
  userSelectedType: string;
  zoneCode: string;
  roadAddress: string;
  jibunAddress: string;
  addressDetail: string;
  gpslat: number;
  gpslon: number;
  loadingMethod: string;
  loadingMethodDescription?: string;
  name: string;
  cellphone: string;
  description: string;
  createDate: string;
  createUser: string;
  updateDate: string;
  updateUser: string;
}

export interface IReceipt {
  orderId: string;
  orderType: TOrderType;
  status: TQuickOrderStatus;
  priceInfo: {
    totalPrice: number;
    cancelFee: number;
  };
  histories: {
    status: TQuickOrderStatus;
    updatedAt: string;
  }[];
}

// 퀵 상세
export interface IQuickOrder {
  quickManagerIdx: number;
  vendor: string;
  vendorOrderId: string;
  userName: string;
  senderName: string;
  receiverName: string;
  goodsInfo: string;
  orderType: string;
  vehicle: string;
  serviceType: string;
  companyPrice: number;
  salesRate: string;
  salesPrice: number;
  serviceFeeRate: string;
  serviceFee: number;
  cancelFee: number;
  totalFee: number;
  supplyPrice: number;
  vat: number;
  pickupRequestDate: string;
  bookingDate: string;
  status: string;
}

export interface IQuickOrderDetail {
  amount: number;
  appointmentDate: string;
  bonusAmount: number;
  bonusAmountReason: number;
  cancelBy: null;
  cancelFee: number;
  cancelReason: null;
  comId: string;
  companyPrice: number;
  createDate: string;
  createUser: string;
  dispatchType: string;
  displayStatus: TDisplayStatus;
  displayStatusLog: {
    status: TDisplayStatus;
    updatedAt: string;
  }[];
  goodsCnt: number;
  goodsInfo: string;
  isExpress: string;
  isNeedCarry: string;
  isRain: string;
  isRidePassenger: string;
  isRoundTrip: string;
  isSnow: string;
  orderId: string;
  orderType: string;
  orgPrice: string;
  pay: string;
  quickAddressList: IQuickAddress[];
  quickGoodsType: string;
  quickManagerIdx: number;
  receipt: string;
  remark: string;
  serviceType: 'QUICK' | 'TRUCK';
  salesPrice: number;
  salesRate: string;
  status: string;
  supplyAmount: number;
  totalAmount: number;
  totalFee: number;
  totalPrice: string;
  updateDate: string;
  updateUser: string;
  userId: string;
  userName: string;
  vehicle: string;
  vendor: string;
  vendorOrderId: string;
}

// 퀵 예약내역
export interface IQuickOrderList {
  content: IQuickOrder[];
  // 타입 정의는 되어있지만 사용하지 않음
  totalPages: number;
  totalElements: number;
  last: boolean;
  first: boolean;
  size: number;
  number: number;
  sort: boolean;
  numberOfElements: number;
  empty: boolean;
  pageable: {
    pageNumber: number;
    size: number;
    sort: string[];
  };
}

// 주소록 목록
export interface IOrderAddress {
  addressBookIdx: number;
  addressBookName: string;
  userSelectedType: string;
  zonecode: string;
  roadAddress: string;
  jibunAddress: string;
  addressDetail: string;
  gpslat: number;
  gpslon: number;
  name: string;
  cellphone: string;
  updateUser: string;
  updateDate: string;
}

export interface IOrderAddressList {
  content: IOrderAddress[];
  pageable: {
    page: number;
    size: number;
    sort: string[];
  };
  totalPages: number;
  totalElements: number;
  last: true;
  first: true;
  size: number;
  number: number;
  sort: string[];
  numberOfElements: number;
  empty: true;
}

// 퀵 예약
export interface IQuickOrderAddress
  extends Omit<IOrderAddress, 'addressBookIdx' | 'addressBookName' | 'updateUser' | 'updateDate'> {
  addressBookName?: string;
  isSaveAddress: boolean;
  description?: string;
  loadingMethod?: string;
  loadingMethodDescription?: string;
}

export interface IQuickBookingParams {
  orderType: TOrderType;
  goodsType: TQuickGoods;
  goodsInfo?: string;
  remark?: string;
  appointmentDate: Moment | string;
  vehicle?: TVehicle;
  pickup?: IQuickOrderAddress;
  dropoff?: IQuickOrderAddress;
}

// ####### quick enum

export const QUICK_TYPE = { QUICK: '퀵', QUICK_ECONOMY: '퀵 이코노미', QUICK_EXPRESS: '퀵 급송' };

export const GOODS_SIZE_CATEGORIES = {
  // kakao
  XS: '서류 / 초소형',
  S: '소형',
  M: '중형',
  L: '대형',
  // gogox
  DOCUMENTS: '소량의 서류',
  SMALLBOX: '소형',
  BIGBOX: '대형',
  OTHERS: '기타'
};

export const QUICK_LOADING_METHOD = {
  USER: '고객이 상하차',
  TOGETHER: '같이 상하차',
  PICKER: '기사님이 상하차'
};

export const QUICK_DISPLAY_STATUS = {
  ORDER_CANCELLED: '접수 취소',
  ORDER_RECEIVED: '배송 접수',
  DRIVER_ASSIGNED: '배차 완료',
  PICKUP_COMPLETE: '픽업 완료',
  DELIVERY_COMPLETE: '배송 완료'
};

export const QUICK_DISPLAY_STATUS_STYLE = {
  ORDER_CANCELLED: '#343a40',
  ORDER_RECEIVED: '#0066ff',
  DRIVER_ASSIGNED: '#0066ff',
  PICKUP_COMPLETE: '#0066ff',
  DELIVERY_COMPLETE: '#30B843'
};

export const QUICK_VEHICLE = {
  // kakao
  MOTORCYCLE: '오토바이',
  DAMAS: '다마스',
  LABO: '라보',
  TON: '1톤 트럭',
  JIMBAJI_MOTORCYCLE: '짐받이 오토바이',
  PASSENGER_CAR: '승용차',
  // gogox
  'motorcycle.None': '오토바이',
  'damas.None': '다마스'
};

export const SERVICE_TYPE_OPTION = {
  QUICK: '퀵',
  TRUCK: '화물'
};

export interface ICodeText {
  code: string;
  text: string;
}

// 퀵 사용자 권한 목록의 사용자
export interface IQuickAuthUser {
  id: string;
  signId: string;
  name: string;
  division: string;
  email: string;
  cellPhone: string;
  position: string;
  rankPosition: string;
  joinDate: number;
  status: ICodeText;
  captainPaymentGrade: ICodeText;
  // 보유한 메뉴 권한 idx 목록. 퀵대장 사용여부는 member/v1/auth 의
  // QUICK 서비스 '이용 가능' menuAuthIdx 보유 여부로 판정한다
  menuAuthIdxList: number[];
}

export interface IQuickUserAuthList {
  paging: {
    page: number;
    pageRow: number;
    totalCount: number;
  };
  user: IQuickAuthUser[];
}

// 퀵 사용자 권한 목록 조회 파라미터 (미지정 항목은 전체 조회)
export interface IQuickUserAuthParams {
  status?: 'ACTIVE' | 'INACTIVE';
  // 퀵 사용여부 필터 — 두 값을 세트로 보낸다.
  // 사용가능: quickUsable=true, menuAuthIdx=이용 가능 idx(3)
  // 사용불가: quickUsable=false, menuAuthIdx=접근 불가 idx(1)
  // idx 는 member/v1/auth 응답에서 권한명으로 찾아 쓴다
  quickUsable?: boolean;
  menuAuthIdx?: number;
  keyword?: string;
  // TODO: 부서 필터는 전달받은 API 스펙에 누락된 항목 — 파라미터명 확정되면 수정 필요
  orgCode?: string;
  page: number;
  pageRow: number;
}

// 사용자별 퀵 사용여부 변경 파라미터
// 퀵 관련 idx 만 교체한 전체 목록을 보내 다른 서비스 권한은 그대로 유지한다
export interface IQuickUserUseParams {
  userId: string;
  menuAuthIdxList: number[];
}

// 사용자별 변경 결과. text 는 응답 result.text (없으면 code·HTTP status 로 구성)
export interface IQuickUserUseResult {
  ok: boolean;
  text: string;
}

// 선택 사용자 퀵 사용여부 일괄 변경 파라미터
// 사용자마다 기존 보유 권한이 달라 목록을 각각 담아 보낸다
export interface IQuickUserUseBulkParams {
  users: IQuickUserUseParams[];
  // 순차 처리라 진행 상황을 화면에 알린다
  // eslint-disable-next-line no-unused-vars
  onProgress?: (done: number, total: number) => void;
}

// GET /captain-payment/member/v1/auth — menuAuthIdx ↔ 권한명 매핑표
export interface IMemberMenuAuth {
  menuAuthIdx: number;
  menuAuthName: string;
}

export interface IMemberMenu {
  menuIdx: number;
  menuName: string;
  menuAuth: IMemberMenuAuth[];
}

export interface IMemberServiceAuth {
  serviceType: string;
  serviceName: string;
  menu: IMemberMenu[];
}
